module.exports = __webpack_public_path__ + "static/CodeCup2-186005fb82114d59aa1ec6e66fad5327.jpg";